import React from "react";
import { Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const PopupFeedbackError = ({}) => {
  return (
    <Grid container style={{ backgroundColor: "#fff" }}>
      <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
        <Grid xs={1} item>
          {" "}
          <div className="icon-error-message" />
        </Grid>
        <Grid xs={10} item>
          {" "}
          <Typography
            className="color-primary-dark"
            style={{ marginLeft: "20px", marginTop: "3px" }}
          >
            Errore durante il salvataggio, riprova
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PopupFeedbackError;
